module.exports = __webpack_public_path__ + "static/media/error404.9c569e8f.jpg";